export const CREATE_NEW_ACCOUNT_CONTEXT_NAME = "splash::context::create_new_account::name";
export function checkPasswordStrength(s) {
    if (s.length < 6) {
        return "weak";
    }
    const hasLowercase = /[a-z]/.test(s);
    const hasUppercase = /[A-Z]/.test(s);
    const hasNumber = /[0-9]/.test(s);
    const hasSpecial = /[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?]/.test(s);
    const count = [
        hasLowercase,
        hasUppercase,
        hasNumber,
        hasSpecial
    ].filter(v => v).length;
    if (count >= 3) {
        return "strong";
    }
    else if (count === 2) {
        return "medium";
    }
    else {
        return "weak";
    }
}
export function getPlanTierIcon(value) {
    switch (value) {
        case "standard":
            return "plan-standard";
        case "business":
            return "plan-business";
        case "professional":
            return "plan-professional";
        default:
            return "";
    }
}
export const PLAN_LOCAL_STORAGE_KEY = "plan-information";
